import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "primary",
  ref: "primary"
}
const _hoisted_2 = { class: "timeline" }
const _hoisted_3 = {
  class: "timeline-header",
  ref: "timelineHeader"
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "timeline-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timeline = _resolveComponent("Timeline")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["split-container", _ctx.headerClass]),
    ref: "container"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.primary)))
    ], 512),
    _createElementVNode("div", {
      class: "separator",
      ref: "separator",
      onPointerdown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sepDown && _ctx.sepDown(...args))),
      onTouchmovePassive: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sepTouchMove && _ctx.sepTouchMove(...args))),
      onTouchendPassive: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pointerUp && _ctx.pointerUp(...args))),
      onTouchcancelPassive: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pointerUp && _ctx.pointerUp(...args)))
    }, null, 544),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "swiper" }, null, -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('memories', '{photoCount} photos', { photoCount: _ctx.photoCount })), 1)
      ], 512),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Timeline, { onDaysLoaded: _ctx.daysLoaded }, null, 8, ["onDaysLoaded"])
      ])
    ])
  ], 2))
}